import { PersonDto } from '../../person/models/PersonDto'
import { TenantDto } from './TenantDto'

export type UserDto = {
    id: string
    email: string
    auth0UserId: string
    auth0PicUrl?: string
    tenantId: string
    tenant?: TenantDto
    isActive: boolean
    personId?: string
    userRoles: UserRoles[]
    person?: PersonDto
    // settings
    doNotShowDataPrivacy?: boolean
}

export enum UserRoles {
    ADMIN = 'ADMIN',
    TA = 'TA',
    HM = 'HM',
}
